import 'sass/app.scss';
import './shims/promise.js';

import React from 'react';

import { Provider } from 'mobx-react';

import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';

import * as stores from 'common/stores';
import Loading from './components/loading';

const browserHistory = createBrowserHistory();
const routingStore = new RouterStore();
const history = syncHistoryWithStore(browserHistory, routingStore);

ReactDOM.render(
	<Provider
		routingStore={ routingStore }
		{ ...stores }
		history={ history }
	>
		<Loading fetchStoreData />
	</Provider>,
	document.getElementById('app')
);

if (module.hot) {

	module.hot.accept();
}
